export default __webpack_public_path__ + "static/media/fantastic_bg_1.223a47c6.png";